import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordinal',
  standalone: false,
})
export class OrdinalPipe implements PipeTransform {
  public transform(value: number | string, lang = 'en'): string {
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return '';
    }
    if (lang === 'en' && value) {
      const ones = +value % 10,
        tens = (+value % 100) - ones;
      const suffix = ['th', 'st', 'nd', 'rd'][tens === 10 || ones > 3 ? 0 : ones];
      return `${value}${suffix}`;
    }
    return `${value}.`;
  }
}
